import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';

angular.module('webTools').factory('Dialog', ['$rootScope', '$compile', '$window', 'Auth', 'ModalWindow', 'Project', '$location', '$ngRedux',
    function ($rootScope, $compile, $window, Auth, ModalWindow, Project, $location, $ngRedux) {
        return {
            openDownload: function (downloadType, isFolder, files, isProject) {

                var newScope = $rootScope.$new();

                var reCenter = function () {
                  kendoWindow.data("kendoWindow").center().wrapper.css({ top: '100px' });
                }

                var kendoWindow = $('<div id="downloadDialog" />').kendoWindow({
                    resizable: false,
                    width: '400px',
                    minWidth: '400px',
                    modal: true,
                    draggable: true,
                    title: 'File Options',
                    open: function (e) {
                        this.wrapper.css({ top: '100px' })
                    },
                    close: function (e) {
                        newScope.$destroy();
                        kendoWindow.data("kendoWindow").destroy();
                    },
                    activate: function () {
                        $('.k-overlay').attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                            .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                            .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');

                        $('#downloadDialog').parent().attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                            .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                            .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')

                        kendoWindow.find('.ok-button').click(function () {
                          w.unbind('resize', reCenter);
                            kendoWindow.data("kendoWindow").close().destroy();
                        }).end()
                    }
                });

                var w = angular.element($window);

              w.bind('resize', reCenter);

                newScope.files = files;
                newScope.isFolder = isFolder;
                newScope.downloadType = downloadType;
                newScope.isProject = isProject;

                var dialogTemplate = '<wt-download-dialog is-project="isProject" is-folder="isFolder" download-type="downloadType" file-list="files"></wt-download-dialog>';

                var el = $compile(dialogTemplate)(newScope);

                kendoWindow.data("kendoWindow")
                    .content(el)
                    .center().open();

                newScope.$on("$destroy", function () {
                  w.unbind('resize', reCenter);
                });
            },
            openNewProject: function () {

                var newScope = $rootScope.$new();
                var self = this;

                var kendoWindow = $('<div id="newProjectDialog" style="padding:0"/>').kendoWindow({
                    resizable: false,
                    width: '400px',
                    minWidth: '400px',
                    modal: true,
                    draggable: false,
                    title: 'New Project',
                    open: function (e) {
                        this.wrapper.css({ top: '20%' })
                    },
                    close: function (e) {
                        newScope.$destroy();
                        kendoWindow.data("kendoWindow").destroy();
                    },
                    activate: () => {
                        var el = document.getElementById('projectName');

                        el.focus();
                    }
                });

                var windowContent = '<style>' +
                    '#projectName { border: 1px solid #ccc; }' +
                    '</style>' +
                    '<div id="linkDialog" style="background-color:#fff;padding: 10px 10px 25px 10px;">' +
                    '<div>' +
                    '<input id="projectName" class="login-input" type="text" style="width:100%;" value="" placeholder="Project Name">' +
                    '</div>' +
                    '<input id="submit" type="button" class="ok-button" ng-click="submitUpload()" value="Save" style="margin-right:0" />' +
                    '<input type="button" class="cancel-button" ng-click="$flow.cancel()" value="Cancel" />' +
                    '</div>';

                kendoWindow.data("kendoWindow").title('New Project').content(windowContent).center().open();

                kendoWindow.find('.cancel-button').click(function () {
                    kendoWindow.data("kendoWindow").close().destroy();
                })

                kendoWindow.find('.ok-button').click(function () {

                    var projectName = angular.element('#projectName').val();

                    Project.createProject($rootScope.workingFolder, projectName).then(function (response) {
                        $location.url(`/projects?project=${response.data.id}&page=1`)
                        self.openProjectEditor(response.data.id);
                        kendoWindow.data("kendoWindow").close().destroy();
                    })
                })
            },
            openProjectEditor: function (projectId) {

                var newScope = $rootScope.$new();

                const resizeDialog = () => $('#projectEditorTabstrip .k-grid-content').height($('.project-tab-container').height() - 150 + "px");

                var kendoWindow = $('<div id="projectEditorDialog" style="padding:0"/>').kendoWindow({
                    resizable: false,
                    width: '800px',
                    minWidth: '800px',
                    height: '575px',
                    modal: true,
                    draggable: true,
                    title: 'Edit Project',
                  dragend: () => { ModalWindow.restrictWindowDragging('projectEditorDialog') },
                  open: () => {
                    if (window.innerHeight < 625) {
                      $('.k-window').height(window.innerHeight - 50 + "px");
                    }
                  },
                  close: function (e) {

                    if (newScope.dirty === true) {
                          e.preventDefault();
                        ModalWindow.openConfirmation('You have unsaved changes. Close anyway?', function () {
                            newScope.$destroy();
                            kendoWindow.data("kendoWindow").destroy();
                          });
                      } else {
                          newScope.$destroy();
                          kendoWindow.data("kendoWindow").destroy();
                    }

                    window.setTimeout(() => $rootScope.$broadcast('reloadGrid'))
                  },
                  activate: function () {
                      kendoWindow.find('.cancel-button').click(function () {
                          kendoWindow.data("kendoWindow").close();
                      })
                    resizeDialog();
                  },
                  resize: () => {
                    resizeDialog()
                  }
                });

                Project.getProjectInfo(projectId).then(function (response) {

                    response.data.projectId = projectId;
                    newScope.projectInfo = response.data;
                    newScope.dirty = false;

                    var dialogTemplate = '<wt-project-editor project-info="projectInfo" dirty="dirty"></wt-project-editor>';

                    var el = $compile(dialogTemplate)(newScope);

                    kendoWindow.data("kendoWindow").content(el).center().open();

                    newScope.$on('closeImportDialog', function () {
                        $('#importDialog').data('kendoWindow').close().destroy();
                    })
                });
            }
        }
    }
]);